module.exports = fox._r("images/safari.png", __webpack_public_path__ + "_/_/_/common/frame/images/safari.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/safari.png
// module id = 158
// module chunks = 2